import { AnimationComponent } from '../../../components/animation';

export const DatasetDetailsPage = () => {
    return (
        <AnimationComponent show type="fade-in" duration={300}>
            <div>DatasetDetailsPage</div>
        </AnimationComponent>
    );
};
